import { installStaticAnalyticsClicks } from './lib/analytics';

installStaticAnalyticsClicks();
